import defaultParams, { showWarningsForParams } from './params'

const prepareParams = (userParams) => {
  return Object.assign({}, defaultParams, userParams)
}

export function main (userParams) {
  showWarningsForParams(userParams)

  const innerParams = prepareParams(userParams)
  Object.freeze(innerParams)
}
